import { useState } from "react";

import type { ITransformedDomain } from "../utils/transformData";

export const useSearchFilter = <T extends { domain: ITransformedDomain }>(data: T[]) => {
    const [search, onSearchChange] = useState("");

    return {
        data: search ? data.filter((item) => item.domain.value.includes(search)) : data,
        onSearchChange,
    };
};
